module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/thumbs-down-4b666c0bfb54cbe2478b0d6e604bcffa.svg";